import React from 'react'

export default function Close({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 23"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g stroke="#000" transform="translate(-312 -115)">
          <g transform="translate(25 98)">
            <g transform="translate(273 4)">
              <g transform="translate(14 14)">
                <path d="M0.138 0L20.644 20.506" />
                <path d="M20.506 0.232L0 20.739" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
